import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';

export interface ActiveInputBoxModelState {
  activeInputBoxModel?: string;
}

const initialState = {
  activeInputBoxModel: undefined,
} as ActiveInputBoxModelState;

export const activeInputBoxModelSlice = createSlice({
  name: 'activeInputBoxModel',
  initialState,
  reducers: {
    setActiveInputBoxModel: (
      state,
      { payload }: PayloadAction<string | undefined>,
    ) => {
      state.activeInputBoxModel = payload;
    },
  },
});

export const activeInputBoxModelState = (state: RootState) =>
  state.activeInputBoxModel as ActiveInputBoxModelState;

export const { setActiveInputBoxModel } = activeInputBoxModelSlice.actions;

export default activeInputBoxModelSlice.reducer;
